import { render, staticRenderFns } from "./OpportunityDocuments.vue?vue&type=template&id=519cf534&"
import script from "./OpportunityDocuments.vue?vue&type=script&lang=js&"
export * from "./OpportunityDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports